import React, { useState, useEffect } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import Navbar from '../components/common/Navbar';
import Sidebar from '../components/common/Sidebar';
import AttendanceUpload from '../components/attendance/AttendanceUpload';
import AttendanceTable from '../components/attendance/AttendanceTable';
import AttendanceFilters from '../components/attendance/AttendanceFilters';
import AttendanceLockModal from '../components/attendance/AttendanceLockModal';
import AttendanceCalendarView from '../components/attendance/calendar/AttendanceCalendarView';
import DSADSAnalytics from '../components/attendance/DSADSAnalytics';
import { getAttendance } from '../services/firebase/attendanceService';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import '../assets/css/attendance.css';
const AttendancePage = () => {
    const { user } = useAuth();
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [year, setYear] = useState(new Date().getFullYear());
    const [isLocked, setIsLocked] = useState(false);
    const [activeTab, setActiveTab] = useState('view');
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        checkLockStatus();
    }, [month, year]);

    const checkLockStatus = async () => {
        try {
            // Lock status check - simplified for Firebase
            setIsLocked(false);
        } catch (error) {
            console.error('Error checking lock status:', error);
        }
    };

    const handleUploadSuccess = (data) => {
        if (data) {
            if (data.month) {
                setMonth(data.month);
            }
            if (data.year) {
                setYear(data.year);
            }
            setRefreshKey(prev => prev + 1); // Trigger refresh
            if (data.recordCount > 0) {
                setActiveTab('view');
            }
        }
    };

    const isPrivilegedUser = user?.role === 'admin' || user?.role === 'hr' || user?.role === 'manager';
    const isHROrAdmin = user?.role === 'admin' || user?.role === 'hr';

    return (
        <div className="d-flex" style={{ width: '100%', overflowX: 'hidden' }}>
            <Sidebar />
            <div className="flex-grow-1 attendance-main-content">
                <Navbar />
                <Container fluid className="py-3 py-md-4 px-2 px-md-4">
                    <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3 mb-3 mb-md-4">
                        <h2 className="fw-bold text-dark mb-0 fs-4 fs-md-2">Attendance Management</h2>
                        {activeTab !== 'calendar' && (
                            <div className="d-flex gap-2 w-100 w-sm-auto">
                                <select className="form-select border-0 shadow-sm rounded-3 fw-bold bg-white flex-grow-1 flex-sm-grow-0" style={{ minWidth: '120px' }} value={month} onChange={(e) => setMonth(parseInt(e.target.value))}>
                                    {Array.from({ length: 12 }, (_, i) => (
                                        <option key={i + 1} value={i + 1}>
                                            {new Date(0, i).toLocaleString('default', { month: 'long' })}
                                        </option>
                                    ))}
                                </select>
                                <select className="form-select border-0 shadow-sm rounded-3 fw-bold bg-white flex-grow-1 flex-sm-grow-0" style={{ minWidth: '90px' }} value={year} onChange={(e) => setYear(parseInt(e.target.value))}>
                                    {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(y => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>

                    {/* Responsive Swipeable Tabs on Mobile */}
                    <div className="attendance-page-tabs mb-3">
                        <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
                            {isPrivilegedUser && (
                                <Tab eventKey="upload" title="Upload">
                                    <AttendanceUpload month={month} year={year} onUploadSuccess={handleUploadSuccess} />
                                </Tab>
                            )}

                            <Tab eventKey="calendar" title="Calendar View">
                                <AttendanceCalendarView key={refreshKey} />
                            </Tab>

                            <Tab eventKey="view" title="View Attendance">
                                <AttendanceTable key={refreshKey} month={month} year={year} isLocked={isLocked} />
                            </Tab>

                            <Tab eventKey="dsads" title="DSADS Analysis">
                                <DSADSAnalytics month={month} year={year} />
                            </Tab>
                        </Tabs>
                    </div>
                </Container>
            </div>
        </div>
    );
};

export default AttendancePage;
